import { useParams } from 'react-router-dom';

import { useParticipantQuery } from './index';

export const useParticipantTimeZone = () => {
  const { email } = useParams();
  const { participant } = useParticipantQuery(email);

  return participant.timezone;
};
